module.exports = __webpack_public_path__ + "static/media/icon-not-save.21347b95.svg";